import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { selectUserRoles } from 'store/global'
import messages from './messages'
import styles from './UserRole.scss'

export default function UserRole({ user }) {
  const allUserRoles = useSelector(selectUserRoles)

  const { roleId } = user
  if (!roleId) return null

  const userRole = allUserRoles.find(({ id }) => id === roleId)

  if (!userRole) return null

  return (
    <span className={styles.role}>
      <FormattedMessage {...messages.roles[userRole.name]} />
    </span>
  )
}

UserRole.propTypes = {
  user: PropTypes.object.isRequired,
}
